import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import { MdDelete } from 'react-icons/md';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { api } from '../../Api-Endpoints/apiEndpoint';
import {
  ResetOrganization,
  UpdateOrganizationSuccess,
} from '../../Redux/OrganizationSlice';
import toast from 'react-hot-toast';
import Select from 'react-select';

const EditOrganizationModal = ({ showModal, onClose }) => {
  const dispatch = useDispatch();
  const { procedures, organization, isSelectedOrg, users, _roles } =
    useSelector(
      state => ({
        procedures: state.Procedure.procedures,
        organization: state.Organization.organization,
        isSelectedOrg: state.Organization.isSelectedOrg,
        users: state.Users.users,
        _roles: state.Roles._roles,
      }),
      shallowEqual
    );
  const [organizationInput, setOrganizationInput] = useState({
    name: '',
    email: '',
    password: '',
    code: '',
    roles: [],
    users: [],
  });
  useEffect(() => {
    if (isSelectedOrg) {
      const newOrg = {
        name: organization.name,
        email: organization.email,
        password: organization.password,
        code: organization.code,
        roles: organization._roles.map((_pro, index) => ({
          id: _pro._id,
          name: _pro.name,
        })),
        users: organization.users.map((_user, index) => ({
          id: _user.user._id,
          name: `${_user.user.firstName} ${_user.user.lastName}`,
        })),
      };
      setOrganizationInput(newOrg);
      dispatch(ResetOrganization());
    }
  }, [isSelectedOrg]);
  function closeModal() {
    setOrganizationInput({
      name: '',
      email: '',
      password: '',
      code: '',
      roles: [],
      users: [],
    });
    onClose();
  }

  const inputHandle = (eventOrName, selectedOptions) => {
    if (typeof eventOrName === 'string') {
      // Handling multi-select inputs
      const values = selectedOptions
        ? selectedOptions.map(option => {
            const [id, ...rest] = option.value.split('-');
            return { id, name: rest.join('-') };
          })
        : [];

      setOrganizationInput(prev => ({
        ...prev,
        [eventOrName]: values,
      }));
    } else {
      // Handling text inputs
      const { name, value } = eventOrName.target;
      setOrganizationInput(prev => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const rolesOptions = _roles.map(role => ({
    value: `${role._id}-${role.name}`,
    label: role.name,
  }));

  const usersOptions = users.map(user => ({
    value: `${user._id}-${user.firstName} ${user.lastName}`,
    label: `${user.firstName} ${user.lastName}`,
  }));

  // Handle change for react-select
  const handleChange = (name, selectedOptions) => {
    inputHandle(name, selectedOptions);
  };

  const submitOrganization = async () => {
    try {
      console.log(organizationInput);
      const { status, data } = await api.patch(
        `/org/org-update/${organization?._id}`,
        {
          org: organizationInput,
        }
      );
      if (status === 201) {
        toast.success('Organization updated successfully.');
        dispatch(UpdateOrganizationSuccess(data._orgnizationUpdate));
        setOrganizationInput({
          name: '',
          email: '',
          password: '',
          code: '',
          roles: [],
          users: [],
        });
        closeModal();
      }
    } catch (error) {
      console.log(error.message);
    }
  };
  return (
    <div>
      {showModal && (
        <Modal
          isOpen={showModal}
          onRequestClose={closeModal}
          contentLabel="Example Modal"
          style={{
            content: {
              width: '50%',
              height: '46%',
              margin: 'auto',
              borderRadius: '20px',
              padding: 0,
            },
            overlay: {
              backgroundColor: 'rgba(0, 0, 0, 0.7)',
            },
          }}
        >
          <div className="flex justify-between  mx-5 my-3">
            <h1 className="text-2xl font-semibold">Edit Organization</h1>
            <button onClick={closeModal}>
              <IoMdCloseCircleOutline size={20} />
            </button>
          </div>
          <hr />

          <div className="flex justify-between items-center mx-5 my-5 gap-5">
            <div>
              <div className="flex justify-between gap-5 my-3">
                <div>
                  <p>
                    Organization Name<span className="text-red-500">*</span>
                  </p>
                  <input
                    className="p-2 w-full border rounded-lg text-sm outline-none my-1"
                    type="text"
                    id="organizationName"
                    placeholder="Enter Name"
                    name="name"
                    value={organizationInput.name}
                    onChange={inputHandle}
                  />
                </div>
              </div>
              <div className="flex justify-between gap-5 my-3">
                <div>
                  <p>
                    Code<span className="text-red-500">*</span>
                  </p>
                  <input
                    className="p-2 w-44 border rounded-lg text-sm outline-none my-1"
                    type="text"
                    id="code"
                    placeholder="Code"
                    name="code"
                    value={organizationInput.code}
                    onChange={inputHandle}
                  />
                </div>
                {/* <div>
                  <p>
                    Email<span className="text-red-500">*</span>
                  </p>
                  <input
                    className="p-2 w-44 border rounded-lg text-sm outline-none my-1"
                    type="text"
                    id="email"
                    placeholder="Enter Email"
                    name="email"
                    value={organizationInput.email}
                    onChange={inputHandle}
                  />
                </div>
                <div>
                  <p>
                    Password<span className="text-red-500">*</span>
                  </p>
                  <input
                    className="p-2 w-44 border rounded-lg text-sm outline-none my-1"
                    type="password"
                    id="password"
                    placeholder="Enter Password"
                    name="password"
                    value={organizationInput.password}
                    onChange={inputHandle}
                  />
                </div> */}
              </div>

              <div>
                <div>
                  <p>
                    Assign Roles<span className="text-red-500">*</span>
                  </p>
                  <Select
                    className=" w-full text-sm my-1"
                    options={rolesOptions}
                    onChange={selectedOptions =>
                      handleChange('roles', selectedOptions)
                    }
                    isMulti
                    placeholder="--Select Roles--"
                    value={rolesOptions.filter(option =>
                      organizationInput.roles.some(
                        role => role.id === option.value.split('-')[0]
                      )
                    )}
                  />
                </div>

                <div>
                  <p>
                    Assign Users<span className="text-red-500">*</span>
                  </p>
                  <Select
                    className=" w-full text-sm my-1"
                    options={usersOptions}
                    onChange={selectedOptions =>
                      handleChange('users', selectedOptions)
                    }
                    isMulti
                    placeholder="--Select Users--"
                    value={usersOptions.filter(option =>
                      organizationInput.users.some(
                        user => user.id === option.value.split('-')[0]
                      )
                    )}
                  />
                </div>
              </div>
            </div>

            <div className="w-full ">
              <h3>Roles List</h3>
              <div className="w-full h-[200px] bg-purple-100 border-none rounded-lg p-5">
                {organizationInput.roles.map((_pro, _index) => {
                  return (
                    <div className="flex justify-between">
                      <p>{_pro.name}</p>
                      <MdDelete
                        className="cursor-pointer"
                        onClick={() => {
                          setOrganizationInput(prev => ({
                            ...prev,
                            roles: prev.roles.filter(
                              (__pro, __index) => __index !== _index
                            ),
                          }));
                        }}
                      />
                    </div>
                  );
                })}
              </div>
            </div>

            <div className="w-full ">
              <h3>Users List</h3>
              <div className="w-full h-[200px] bg-purple-100 border-none rounded-lg p-5">
                {organizationInput.users.map((_pro, _index) => {
                  return (
                    <div className="flex justify-between">
                      <p>{_pro.name}</p>
                      <MdDelete
                        className="cursor-pointer"
                        onClick={() => {
                          setOrganizationInput(prev => ({
                            ...prev,
                            users: prev.users.filter(
                              (__pro, __index) => __index !== _index
                            ),
                          }));
                        }}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div className=" flex justify-end mx-5 my-3 gap-3">
            <button
              onClick={closeModal}
              className="border border-red-500 p-1 px-5 rounded-lg"
            >
              Cancel
            </button>
            <button
              onClick={submitOrganization}
              className="border bg-red-500 p-1 px-5 rounded-lg text-white"
            >
              Save & Update
            </button>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default EditOrganizationModal;
